import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=7842da82&scoped=true&"
import script from "./DashboardCharts.vue?vue&type=script&lang=js&"
export * from "./DashboardCharts.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCharts.vue?vue&type=style&index=0&id=7842da82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7842da82",
  null
  
)

component.options.__file = "DashboardCharts.vue"
export default component.exports